import { AttendanceFlag, DaySchedule } from './applicant-schedule.interface';

export enum ClassType {
  INDUCEMENT = 'INDUCEMENT',
  VEMO_UNI_CLASS_1 = 'VEMO_UNI_CLASS_1',
  VEMO_UNI_CLASS_2 = 'VEMO_UNI_CLASS_2',
}

export interface AttendanceRedemptionRequest {
  attendanceRedemption: {
    code: string;
  };
}

export interface AttendanceRegistration {
  attendanceClassId: number;
  className: string;
  classDay: string;
}

export interface AttendanceRegistrationResponse {
  attendanceRegistration: AttendanceRegistration;
}

export interface DayModalData {
  props: Pick<DaySchedule, 'locationName' | 'locationAddress' | 'schedule'>;
  classDate: string;
  classType: ClassType | null;
  trainingId: string;
  attendanceRegistered: AttendanceFlag;
}

export interface AttendanceModalData {
  trainingId: string;
}
